import React from "react";
import Logo from "../img/mainbg.png";
import "../App.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import Circle from "../img/circle.svg";

function Banner() {
  return (
    <div className="banner">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="banner-text text-left animated animatedFadeInUp fadeInUp">
              <h4 className="">We are Famoron</h4>
              <img
                className="about-image"
                src={Circle}
                alt="images"
                className="circle"
              />
              <h1 className="title-font">We Bring Ideas to Life</h1>
              <p className="banner-description">
                We are a team of Design Engineers, Developeers and Brand
                strategists who create beautiful products.
              </p>
              <button className="btn bodybutton" href="#projects">
                <FontAwesomeIcon
                  icon={faArrowDown}
                  className="bodybutton-icon"
                />
                &nbsp; Explore Our Projects
              </button>
            </div>
          </div>
          <div className="banner-image-mobile">
            <div className="col-lg-6">
              <div className="banner-area">
                <img className="banner-image" src={Logo} alt="images" />
              </div>
            </div>
          </div>
          <div className="banner-image-desktop col-lg-6">
            <div className="banner-area">
              <img className="banner-image" src={Logo} alt="images" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
